'use client';

import { useConsent } from '@lichtblick/consent/hooks/useConsent';
import Script from 'next/script';
import { type FC, useCallback, useEffect } from 'react';

import type { OHubspotFormType } from '../../types/storyblok';

const formIdByFormOption: Record<OHubspotFormType['form'], string> = {
  flottenkampagne: 'e1eaf52e-bbab-48fa-bba4-a434b0d5e776',
  'e-lkw-kampagne': 'a82eaba4-3dc8-48fa-9103-8825bbbf749a',
  'hypercharger-kampagne': 'fe28dcbd-2d97-4987-a374-5947b97750bc',
  'b2b-emob': 'ebf80417-cba2-44f7-a01e-2c17c6bad7da',
};

type Props = {
  form: OHubspotFormType['form'];
};

export const HubSpotFormScript: FC<Props> = ({ form }) => {
  const linkedinConsent = useConsent('LinkedIn Ads');
  const facebookConsent = useConsent('Facebook Pixel');
  const googleAdsConsent = useConsent('Google Ads');
  const googleCustomerMatchConsent = useConsent('Google Customer Match');

  const hubspotEventHandler = useCallback(
    (event: any) => {
      if (event?.data?.type === 'hsFormCallback' && event?.data?.eventName === 'onFormSubmit') {
        const _hsq = (window as any)._hsq ?? [];

        _hsq.push([
          'trackCustomBehavioralEvent',
          {
            name: 'pe143379264_usercentrics_consent_given',
            properties: {
              consent_status_meta: facebookConsent ? 'granted' : 'revoked',
              consent_status_linkedin: linkedinConsent ? 'granted' : 'revoked',
              consent_status_google_ads: googleAdsConsent ? 'granted' : 'revoked',
              consent_status_google_customer_match: googleCustomerMatchConsent ? 'granted' : 'revoked',
            },
          },
        ]);

        _hsq.push(['trackPageView']);
      }
    },
    [linkedinConsent, facebookConsent, googleAdsConsent, googleCustomerMatchConsent],
  );

  useEffect(() => {
    window.addEventListener('message', hubspotEventHandler);

    return () => window.removeEventListener('message', hubspotEventHandler);
  }, [hubspotEventHandler]);

  return (
    <Script
      id="hubspot-contact-form-script"
      onReady={() => {
        (window as any).hbspt.forms.create({
          region: 'eu1',
          portalId: '143379264',
          formId: formIdByFormOption[form],
          target: '#hubspot-contact-form',
        });
      }}
      src="//js-eu1.hsforms.net/forms/embed/v2.js"
      type="text/javascript"
    />
  );
};
